/**
 * Absolute URLs to pages outside the member portal (marketing site, etc.).
 * Not in pathConstants: those entries are in-app React Router paths only.
 */
export const GENOMIC_LIFE_REFERRAL_INVITE_URL =
  "https://www.genomiclife.com/invite";

/** Host + path for invite URL in body copy (matches {@link GENOMIC_LIFE_REFERRAL_INVITE_URL}). */
export const GENOMIC_LIFE_REFERRAL_INVITE_LINK_LABEL = "genomiclife.com/invite";

export const GENOMIC_LIFE_GIFTS_PAGE_URL = "https://www.genomiclife.com/gifts";

/** Host + path for gifts URL in body copy (matches {@link GENOMIC_LIFE_GIFTS_PAGE_URL}). */
export const GENOMIC_LIFE_GIFTS_PAGE_LINK_LABEL = "genomiclife.com/gifts";
